import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import * as IPurchases from '../../../../../interfaces/merchants/products/purchases';
import scrollToTop from '../../../../hoc/scrollToTop';
import PurchaseSubmitButton from '../common/buttons/PurchaseSubmitButton';
import PurchaseErrorMessage from '../common/forms/PurchaseErrorMessage';

import css from './CompletionFailed.module.scss';

interface ElementProps {
  schemeType: IPurchases.SchemeType;
  settings: IPurchases.SettingCompletion;
  backTo?: {
    label: string;
    modifyPage: () => void;
  };
}

type Props = ElementProps & InjectedIntlProps;

const CompletionFailed: React.SFC<Props> = (props: Props) => {
  const { schemeType, settings, backTo, intl } = props;
  const labelType =
    schemeType === IPurchases.SchemeType.Subscription
      ? 'subscription'
      : 'ticketBook';
  return (
    <div className={css.CompletionFailed}>
      {settings.entireErrors!.map(errorType => (
        <PurchaseErrorMessage
          key={errorType}
          labelType={labelType}
          errorType={errorType}
          className={css.CompletionFailed__ErrorMessage}
        />
      ))}
      {backTo && (
        <PurchaseSubmitButton
          onClick={backTo.modifyPage}
          value={intl.formatMessage({
            id: backTo.label,
          })}
        >
          {intl.formatMessage({
            id: backTo.label,
          })}
        </PurchaseSubmitButton>
      )}
    </div>
  );
};

export default injectIntl(scrollToTop(CompletionFailed));
